import { render, staticRenderFns } from "./ManageWorkspaceModal.vue?vue&type=template&id=456601a8&"
import script from "./ManageWorkspaceModal.vue?vue&type=script&lang=js&"
export * from "./ManageWorkspaceModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports